import { Types } from '../../../actions/content/layers'
import { formatLayer, updateLayer } from './helpers'

export default (state, { type, payload = {}, meta = {} }) => {
    switch (type) {
        case Types.FETCH_LAYERS_REQUEST:
            return {
                ...state,
                isWorking: {
                    ...state.isWorking,
                    layers: true,
                },
            }
        case Types.API_CALL_FAILURE:
        case Types.FETCH_LAYERS_FAILURE:
            // It failed when fetching layers list
            return {
                ...state,
                isWorking: {
                    ...state.isWorking,
                    layers: false,
                },
            }
        case Types.FETCH_LAYERS_SUCCESS:
            // It failed when fetching layers list
            return {
                ...state,
                isWorking: {
                    ...state.isWorking,
                    layers: false,
                },
                layers: meta.noFirstPage ? [...state.layers, ...payload.data.map(formatLayer)] : payload.data.map(formatLayer),
                pagination: {
                    ...state.pagination,
                    layers: {
                        currentPage: payload.current_page,
                        perPage: payload.per_page,
                        total: payload.total,
                        from: payload.from,
                        to: payload.to,
                    },
                },
            }
        case Types.APPROVE_LAYER_REQUEST:
        case Types.RETRY_UPLOAD_LAYER_REQUEST: {
            // Sets a single item as it is being working with it
            const { layerID, inSelectedPlaylist } = meta
            return updateLayer(state, layerID, { isWorking: true }, inSelectedPlaylist)
        }
        case Types.APPROVE_LAYER_FAILURE: {
            // Unsets the `isWorking` flag from an item
            const { layerID, inSelectedPlaylist } = meta
            return updateLayer(state, layerID, { isWorking: false }, inSelectedPlaylist)
        }
        case Types.APPROVE_LAYER_SUCCESS:
        case Types.RETRY_UPLOAD_LAYER_SUCCESS: {
            // Updates a single item
            const { id: layerID } = payload
            const { inSelectedPlaylist } = meta
            return updateLayer(state, layerID, formatLayer(payload), inSelectedPlaylist)
        }
        case Types.CHANGE_LAYERS:
            return {
                ...state,
                layers: payload,
            }
        case Types.CREATE_LAYER_SUCCESS:
            return {
                ...state,
                layers: [...state.layers, payload],
            }
        default:
            return null
    }
}
